export const commonCompetitorMatches = {
  matchUpStatistics: {
    commonCompetitors: [
      {
        id: 'nboe8hp1n3--1',
        nativeGivenName: 'jessie',
        nativeFamilyName: 'higaTOLower',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 33.07,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 30.15,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 10,
          wins: 4,
          losses: 6,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 7,
          wins: 3,
          losses: 4,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-0',
        nativeGivenName: 'Jessie',
        nativeFamilyName: 'HigaTO',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 33.07,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 30.15,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 10,
          wins: 4,
          losses: 6,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 7,
          wins: 3,
          losses: 4,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-1',
        nativeGivenName: 'Athena',
        nativeFamilyName: '',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 28.07,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 29,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 5,
          wins: 4,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 3,
          wins: 2,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-2',
        nativeGivenName: 'Ashxxx',
        nativeFamilyName: 'Kurizxxx',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 27.21,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 26.75,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 2,
          wins: 1,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 1,
          wins: 1,
          losses: 0,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-3',
        nativeGivenName: 'Lanie',
        nativeFamilyName: 'Takahashi',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 26.78,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 31.45,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 5,
          wins: 2,
          losses: 3,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 9,
          wins: 5,
          losses: 4,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-4',
        nativeGivenName: 'Sophia',
        nativeFamilyName: 'Kato',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 28.21,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 35.33,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 1,
          wins: 0,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 1,
          wins: 1,
          losses: 0,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-5',
        nativeGivenName: 'Jake',
        nativeFamilyName: 'Tokuuke',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 30.61,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 30.77,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 2,
          wins: 1,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 1,
          wins: 1,
          losses: 0,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-6',
        nativeGivenName: 'Annika',
        nativeFamilyName: 'Nishida',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 29.41,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 32.96,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 5,
          wins: 3,
          losses: 2,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 1,
          wins: 0,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-7',
        nativeGivenName: 'Chloe',
        nativeFamilyName: 'Takahashi',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 27.38,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 29.64,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 11,
          wins: 11,
          losses: 0,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 1,
          wins: 1,
          losses: 0,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-8',
        nativeGivenName: 'Drew',
        nativeFamilyName: 'Nakamura',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 23.66,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 29.68,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 2,
          wins: 1,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 3,
          wins: 0,
          losses: 3,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-9',
        nativeGivenName: 'Arabella Marie',
        nativeFamilyName: 'Asuncion',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 30.81,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 32.48,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 11,
          wins: 7,
          losses: 4,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 9,
          wins: 4,
          losses: 5,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-10',
        nativeGivenName: 'Jessie',
        nativeFamilyName: 'Higa',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 33.07,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 30.15,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 10,
          wins: 4,
          losses: 6,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 7,
          wins: 3,
          losses: 4,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-11',
        nativeGivenName: 'Kristen Keiko',
        nativeFamilyName: 'Felte',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 28.67,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 30.16,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 1,
          wins: 0,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 3,
          wins: 2,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-12',
        nativeGivenName: 'Jada',
        nativeFamilyName: 'Igawa',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 25.97,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 24.23,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 5,
          wins: 5,
          losses: 0,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 7,
          wins: 5,
          losses: 2,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-13',
        nativeGivenName: 'Abena',
        nativeFamilyName: '',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 28.07,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 29,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 5,
          wins: 4,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 3,
          wins: 2,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-14',
        nativeGivenName: 'ProFlag',
        nativeFamilyName: 'Player',
        optedOutOfPublicDataConsent: false,
        isRanked: true,
        worldTennisNumbers: [
          {
            tennisNumber: 0,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 29,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 5,
          wins: 4,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 3,
          wins: 2,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
      {
        id: 'nboe8hp1n3-15',
        nativeGivenName: 'Athena',
        nativeFamilyName: 'c',
        optedOutOfPublicDataConsent: false,
        isRanked: false,
        worldTennisNumbers: [
          {
            tennisNumber: 10,
            type: 'SINGLE',
            __typename: 'PersonRating',
          },
          {
            tennisNumber: 29,
            type: 'DOUBLE',
            __typename: 'PersonRating',
          },
        ],
        nationalityCode: 'USA',
        p1Vs: {
          totalMatches: 5,
          wins: 4,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        p2Vs: {
          totalMatches: 3,
          wins: 2,
          losses: 1,
          __typename: 'MatchUpVsStatisticsWinLossCount',
        },
        __typename: 'Person',
      },
    ],
    __typename: 'MatchUpVsStatistics',
  },
}
